export const activeStyles = { transform: 'none' };
